<template>
  <div class="ui card" @click="$emit('input', index)">
    <div class="header">
      <h4>
        {{ name }}
        <a v-if="shirt.options[options.id]" class="ui tag label right floated"
          >{{ price }} €</a
        >
      </h4>
    </div>
    <div class="content">
      <div class="ui cards">
        <template v-for="(parameter, index) in options.parameters">
          <template
            v-if="
              shirt.options[options.id][parameter.code] &&
              shirt.options[options.id][parameter.code].picture
            "
          >
            <div :key="index" class="ui card cardimage">
              <div class="image">
                <img
                  alt=" "
                  :src="shirt.options[options.id][parameter.code].picture"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-if="shirt.options[options.id][parameter.code]"
              :key="index"
              class="ui card cardtext"
            >
              <div class="text center aligned middle aligned content">
                {{ shirt.options[options.id][parameter.code].name }}
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  cursor: pointer;
  border-radius: 0;
  width: 100%;
}

.ui.card:last-child {
  margin-bottom: 10px;
}

.card.active {
  background-color: #d7dce7;
  border: 1px solid #d7dce7;
}

.card .header h4 {
  padding: 10px;
}

.card .header h4 .tag {
  margin-top: -4px;
}

.cardimage {
  height: 50px !important;
  width: 50px !important;
}

.image img {
  height: 50px !important;
  width: auto;
}

.cardtext {
  height: 50px !important;
  width: 50px !important;
  overflow: hidden;
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ParametersCard',
  props: {
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      shirt: 'getCurrentShirt'
    }),
    name() {
      const { name } = this.options

      if (this.options.parameters.length === 0) {
        return name
      }

      const firstParamCode = this.options.parameters[0].code
      if (this.shirt.options[this.options.id][firstParamCode]) {
        const value = this.shirt.options[this.options.id][firstParamCode]
        return `${this.options.parameters[0].name}: ${value.name}`
      }

      return name
    },
    price() {
      let price = 0
      this.options.parameters.forEach((parameter) => {
        if (
          this.shirt.options[this.options.id][parameter.code] &&
          this.shirt.options[this.options.id][parameter.code].price
        ) {
          price =
            parseFloat(price) +
            parseFloat(this.shirt.options[this.options.id][parameter.code].price)
        }
      })
      return price
    }
  },
  mounted() {},

  methods: {}
}
</script>



// WEBPACK FOOTER //
// ParametersCard.vue?69f03f29